import React, { useMemo, useState } from 'react';

import CoachingContent from 'pages/Teachers/Home/components/CoachingContent';
import ColumnContainer from 'pages/Teachers/Home/components/ColumnContainer';
import DashboardHeader from 'pages/Teachers/Home/components/DashboardHeader';
import PriorityGradingList from 'pages/Teachers/Home/components/PriorityGradingList';
import StartEmptyBox from 'pages/Teachers/Home/components/StartEmptyBox';
import TommorowFocusContent from 'pages/Teachers/Home/components/TommorowFocusContent';
import { useNavbar } from 'pages/Teachers/shared';

import { ReactComponent as CoachingIcon } from './assets/coaching-icon.svg';
import { ReactComponent as CoachingSmallIcon } from './assets/coaching-small-icon.svg';
import { ReactComponent as FocusIcon } from './assets/focus-icon.svg';
import { ReactComponent as FocusSmallIcon } from './assets/focus-small-icon.svg';
import { ReactComponent as GradingIcon } from './assets/grading-icon.svg';
import { ReactComponent as HomeIcon } from './assets/home-icon.svg';
import { ReactComponent as SearchIcon } from './assets/search-icon.svg';
import { ReactComponent as SettingsIcon } from './assets/settings-icon.svg';
import { ReactComponent as StartIcon } from './assets/start-icon.svg';
import styles from './styles.module.scss';

const Home = () => {
  // Simulate checking if the user is logged or not
  const [isLogged, setIsLogged] = useState(false);

  const navConfig = useMemo(
    () => ({
      title: (
        <div className={styles.navHeaderGroup}>
          <div className={styles.navTitleRow}>
            <HomeIcon className={styles.homeIcon} />
            <span>Home</span>
          </div>
          <div className={styles.navSubtext}>
            Prioritize grading, review patterns, and plan tomorrow's next steps.
          </div>
        </div>
      ),
      RightSubheader: (
        <div className={styles.navSearchContainer}>
          <div className={styles.searchMock}>
            <div className={styles.searchLeft}>
              <SettingsIcon />
              <span className={styles.searchPlaceholderText}>
                Search Assignments, Standards, or Sections here...
              </span>
            </div>
            <SearchIcon />
          </div>
        </div>
      )
    }),
    []
  );

  useNavbar(navConfig);

  return (
    <div className={styles.container}>
      <DashboardHeader setIsLogged={setIsLogged} />

      <div className={styles.grid}>
        {/* COLUMN 1: Priority Grading */}
        <ColumnContainer
          title="START HERE:"
          titleDescription=" Priority Grading"
          smallIcon={<StartIcon />}
          headerRight={
            isLogged ? <span className={styles.countBadge}>14</span> : null
          }
        >
          {isLogged ? (
            <PriorityGradingList />
          ) : (
            <StartEmptyBox
              stepNumber="STEP 1"
              description="Launch your first student mission to see priority grading appear here."
              icon={<GradingIcon />}
              actionLabel="CREATE ASSIGNMENT"
            />
          )}
        </ColumnContainer>

        {/* COLUMN 2: Tomorrow's Focus */}
        <ColumnContainer
          title=""
          titleDescription="Tomorrow's Focus"
          smallIcon={<FocusSmallIcon />}
        >
          {isLogged ? (
            <TommorowFocusContent />
          ) : (
            <StartEmptyBox
              stepNumber="STEP 2"
              description="Reflect on today's data and set goals for your next lesson."
              icon={<FocusIcon />}
            />
          )}
        </ColumnContainer>

        {/* COLUMN 3: PLC / Coaching */}
        <ColumnContainer
          title=""
          titleDescription="Discuss in PLC / Coaching"
          smallIcon={<CoachingSmallIcon />}
        >
          {isLogged ? (
            <CoachingContent />
          ) : (
            <StartEmptyBox
              stepNumber="STEP 3"
              description="Once students submit, we will group them by misconception for your next team meeting."
              icon={<CoachingIcon />}
            />
          )}
        </ColumnContainer>
      </div>
    </div>
  );
};

export default Home;
